module.exports = __webpack_public_path__ + "img/tuiguang3-4.8f574ad5.jpg";